import TagManager from 'react-gtm-module';

import { ATC_SOURCES, type AtcSource } from '@utils/cart/atcSource';
import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export type BundleStripPlacement = 'homepage' | 'cip' | 'clp';

export const BUNDLE_STRIP_ATC_SOURCE_BY_PLACEMENT: Record<
  BundleStripPlacement,
  AtcSource
> = {
  homepage: ATC_SOURCES.HOMEPAGE_BUNDLE_STRIP,
  cip: ATC_SOURCES.CIP_BUNDLE_STRIP,
  clp: ATC_SOURCES.CLP_BUNDLE_STRIP,
};

interface BundleStripEventData {
  interactionLocation: BundleStripPlacement;
  heading: string;
  eventPage: string;
}

export interface TrackBundleCardClickProps extends DeferredNavigationProps {
  data: BundleStripEventData & {
    linkText: string;
    linkUrl: string;
    index: number;
  };
}

export const trackBundleCardClick = ({
  data,
  ...deferral
}: TrackBundleCardClickProps) => {
  const { interactionLocation, heading, eventPage, linkText, linkUrl, index } =
    data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_bundle_card',
      interaction: {
        interaction_location: interactionLocation,
        heading,
        link_text: linkText,
        link_url: linkUrl,
        index,
        event_page: eventPage,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};

export interface TrackBundleCtaClickProps extends DeferredNavigationProps {
  data: BundleStripEventData & {
    linkText: string;
    linkUrl: string;
  };
}

export const trackBundleCtaClick = ({
  data,
  ...deferral
}: TrackBundleCtaClickProps) => {
  const { interactionLocation, heading, eventPage, linkText, linkUrl } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_bundle_cta',
      interaction: {
        interaction_location: interactionLocation,
        heading,
        link_text: linkText,
        link_url: linkUrl,
        event_page: eventPage,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};

export interface TrackBundleAtcClickProps {
  data: BundleStripEventData & {
    linkText: string;
  };
}

export const trackBundleAtcClick = ({ data }: TrackBundleAtcClickProps) => {
  const { interactionLocation, heading, eventPage, linkText } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_bundle_atc',
      interaction: {
        interaction_location: interactionLocation,
        heading,
        link_text: linkText,
        event_page: eventPage,
      },
    },
  });
};
